var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_USERS))?_c('object-link',{attrs:{"object":_vm.user}}):_c('span',[_vm._v(_vm._s(_vm.$objectDenomination(_vm.user)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }